﻿import * as React from 'react';
import { ImageEditorFirmsModal, ImageEditorFirmsModalLabels } from './ImageEditorFirmsModal';
import { IImageEditorFirm } from '../Entities';
import { Translate } from '../../../shared/LanguageService';

type CreateImageEditorFirmModalProps = {
    showModal: boolean;
    onClose: () => void;
    onSave: (imageEditorFirm: IImageEditorFirm) => void;
};

function CreateImageEditorFirmModalTranslationLayer({
    onClose,
    showModal,
    onSave
}: CreateImageEditorFirmModalProps) {
    let labels: ImageEditorFirmsModalLabels = {
        textfieldLegend: Translate('image-editor-firms/modal/textfield-legend'),
        dialogTitle: Translate('image-editor-firms/modal/dialog-title'),
        selectLegend: Translate('image-editor-firms/modal/select-legend'),
        cancelButton: Translate('image-editor-firms/modal/cancel-button'),
        saveButton: Translate('image-editor-firms/modal/create-button'),
        defaultCheckboxLabel: Translate('image-editor-firms/modal/default-checkbox-label'),
        expressCheckboxLabel: Translate('image-editor-firms/modal/express-checkbox-label'),
        deselectionIsNotAllowed: Translate('image-editor-firms/modal/deselection-is-not-allowed')
    };

    return (
        <ImageEditorFirmsModal
            showModal={showModal}
            onClose={onClose}
            labels={labels}
            onSave={onSave}
        />
    );
}

export default CreateImageEditorFirmModalTranslationLayer;
